import { AccountModalActions } from 'account/state/accountModalReducer';
import { triggerLoginBeforeAction } from 'store/slice/accountModalSlice';
import { useAccountModalDispatch } from 'account/hooks/useAccountModal';
import { useStoreDispatch } from 'store/hooks/storeHooks';
import { useWindowSize } from 'shared/hooks/useWindowSize';
import { t } from 'localization/utils/t';

const TP = 'productTemplate.hooks.useLoginBeforeAction';

export const useLogInBeforeAction = () => {
  const storeDispatch = useStoreDispatch();
  const accountModalDispatch = useAccountModalDispatch();
  const { isMobileOrTablet } = useWindowSize();

  const logInBeforeAction = (
    action: () => void,
    modalTitle = t(`${TP}.modalTitle`, 'Log In to Continue'),
    modalButtonText = t(`${TP}.modalButtonText`, 'LOG IN'),
  ) => {
    storeDispatch(
      triggerLoginBeforeAction({
        buttonText: modalButtonText,
        title: modalTitle,
        darkTheme: isMobileOrTablet,
      }),
    );

    if (action) {
      accountModalDispatch({
        type: AccountModalActions.setCallbackFunction,
        payload: action,
      });
    }
  };

  return { logInBeforeAction };
};
